export default __webpack_public_path__ + "static/favicon-b7c825ab0373f4ffe37c301e8edaf352.ico";